export default __webpack_public_path__ + "static/media/nitrogenImage.a1d5ae3b.png";